<template>
  <div class="chart1">
    <bar-chart :chart-data="chartData" :options="chartOptions"></bar-chart>
  </div>
</template>

<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

function formatNumber(value) {
  if (value === null || value === undefined || value === 0) return '-'
  return new Intl.NumberFormat('id-ID').format(value)
}

function formatShortNumber(value) {
  if (value === null || value === undefined) return '-'

  const absValue = Math.abs(value)

  if (absValue >= 1000000000000) return (value / 1000000000000).toFixed(1).replace(/\.0$/, '') + 'T'
  if (absValue >= 1000000000)    return (value / 1000000000).toFixed(1).replace(/\.0$/, '') + 'M'
  if (absValue >= 1000000)       return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'Jt'
  if (absValue >= 1000)          return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K'

  return value.toString()
}

export default {
  name: 'MixedChart',
  components: {
    BarChart: {
      extends: Bar,
      mixins: [reactiveProp],
      props: ['options'],
      mounted () {
        this.renderChart(this.chartData, this.options)
      }
    }
  },
  props: {
    rawData: {
      type: Array,
      required: true
    }
  },
  computed: {
    chartData () {
      const labels = this.rawData.map(item => item.StmtDate)
      const opening = this.rawData.map(item => item.OpeningBalance)
      const closing = this.rawData.map(item => item.ClosingBalance)
      const cashIn = this.rawData.map(item => item.CashIn)
      const cashOut = this.rawData.map(item => item.CashOut)

      return {
        labels: labels,
        datasets: [
          {
            label: 'Opening Balance',
            data: opening,
            borderColor: 'rgba(31, 119, 180, 0.9)',
            backgroundColor: 'rgba(31, 119, 180, 0.9)', //'rgba(54, 162, 235, 0.9)',
            type: 'line',
            fill: false,
            tension: 0.2, //curve bazier for linechart
            datalabels: {
                display: false
            },
            order: 0,
          },
          {
            label: 'Closing Balance',
            data: closing,
            borderColor: 'rgba(255, 127, 14, 0.9)',
            backgroundColor: 'rgba(255, 127, 14, 0.9)', //'rgba(75, 192, 192, 0.9)',
            fill: false,
            type: 'line',
            tension: 0.2, //curve bazier for linechart
            datalabels: {
                display: false
            },
            order: 1
          },
          {
            label: 'Cash In',
            data: cashIn,
            borderColor: 'rgba(44, 160, 44, 1)',
            backgroundColor: 'rgba(44, 160, 44, 0.9)',
            fill: false,
            type: 'bar',
            datalabels: {
                display: false
            },
            order: 2
          },
          {
            label: 'Cash Out',
            data: cashOut,
            borderColor: 'rgba(214, 39, 40, 1)',
            backgroundColor: 'rgba(214, 39, 40, 0.9)',
            fill: false,
            type: 'bar',
            datalabels: {
                display: false
            },
            order: 3
          }
        ]
      }
    },
    chartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true,
                boxWidth: 30,   // default: 40
                boxHeight: 10,   // default: sama tinggi font
                generateLabels: function(chart) {
                    return chart.data.datasets.map((dataset, i) => {
                        const meta = chart.getDatasetMeta(i);
                        const type = dataset.type || chart.config.type;

                        let pointStyle = 'rect'; // default kotak
                        if (type === 'line') {
                            pointStyle = 'line'; // akan tampil sebagai garis dgn titik di tengah
                        }

                        return {
                            text: dataset.label,
                            fillStyle: dataset.backgroundColor,
                            hidden: !chart.isDatasetVisible(i),
                            lineCap: dataset.borderCapStyle,
                            lineDash: dataset.borderDash,
                            lineDashOffset: dataset.borderDashOffset,
                            lineJoin: dataset.borderJoinStyle,
                            lineWidth: dataset.borderWidth,
                            strokeStyle: dataset.borderColor,
                            pointStyle: pointStyle,
                            datasetIndex: i
                        };
                    });
                }
            }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
                label: function(tooltipItem, data) {
                const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                return datasetLabel + ': ' + formatNumber(tooltipItem.yLabel);
                }
            }
        },
        scales: {
            xAxes: [{
                stacked: false
            }],
            yAxes: [{
                stacked: false,
                ticks: {
                beginAtZero: true,
                callback: function(value) {
                        //return '' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                        return formatShortNumber(value);
                    }
                }
            }]
        },
        plugins: {
            datalabels: {
            formatter: function(value) {
                return formatNumber(value);
            }
            }
        }
      }
    }
  }
}
</script>

<style>
.chart1 {
  position: relative;
  height: 400px;
}
</style>
